import { useEffect, useState } from "react";

import { PanesContainer, useNotionDatabase } from "dev";
import DataTable from "react-data-table-component";
import { ScrollView, View } from "react-native";
import { useTailwind } from "tailwind-rn";

import { TrackingHistoryCard } from "../[uuid]";
import { MockDeliveryStatusProvider } from "@/src/contexts/delivery-status-context";
import { fetchDeliveryStatus, cols } from "@/src/services/dev";
import { DeliveryStatus, Status, Substatus } from "@/src/types";

type NotionData = {
  uuid: string;
  tstamp: string;
  status: Status;
  substatus: Substatus<Status>;
};

function scrollTo(uuid: string) {
  document.getElementById(uuid)?.scrollIntoView();
}

export default function Historical() {
  const tailwind = useTailwind();
  const db = useNotionDatabase("8c4fe0fab8f34935930d914dbff0ae7a");

  const [deliveryStatuses, setDeliveryStatuses] = useState<DeliveryStatus[]>(
    []
  );

  const data = db
    ?.map(
      (r) =>
        ({
          uuid: r["Order UUID"],
          tstamp: r["Order Timestamp"],
          status: r["Status"] as Status,
          substatus: r["Sub-status"] as Substatus<Status>,
        } as NotionData)
    )
    .filter((r) => r.uuid && r.tstamp);

  useEffect(() => {
    data?.forEach((r) => {
      if (deliveryStatuses.some((e) => e.order.uuid === r.uuid)) return;
      fetchDeliveryStatus(r).then((d) => {
        setDeliveryStatuses((prev) => [...prev, d]);
      });
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data?.length]);

  if (!data) return null;

  return (
    <ScrollView contentContainerStyle={tailwind("m-4")}>
      <DataTable
        onRowClicked={(r) => scrollTo(r.uuid)}
        pagination
        title={"Examples Rendered"}
        columns={cols([
          ["Status", "status"],
          ["Sub-status", "substatus"],
          ["Timestamp", "tstamp"],
        ])}
        data={data}
      />
      <PanesContainer
        items={deliveryStatuses}
        expectedCount={data?.length}
        renderItem={(deliveryStatus) => (
          <>
            <View nativeID={deliveryStatus.order.uuid}>
              <a href={`/dev/${deliveryStatus.order.uuid}`}>
                uuid: {deliveryStatus.order.uuid}
              </a>
              <span>status: {deliveryStatus.tracking_status.status}</span>
              <span>substatus: {deliveryStatus.tracking_status.substatus}</span>
            </View>

            <MockDeliveryStatusProvider deliveryStatus={deliveryStatus}>
              <TrackingHistoryCard />
            </MockDeliveryStatusProvider>
          </>
        )}
      />
    </ScrollView>
  );
}
